import { render, staticRenderFns } from "./overseas.vue?vue&type=template&id=ab43957c&scoped=true&"
import script from "./overseas.vue?vue&type=script&lang=js&"
export * from "./overseas.vue?vue&type=script&lang=js&"
import style0 from "./overseas.vue?vue&type=style&index=0&id=ab43957c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43957c",
  null
  
)

export default component.exports